var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProgBar5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96.4 358.4",
    style: {
      enableBackground: "new 0 0 96.4 358.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#C7C7C7;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{opacity:0.6;fill:url(#SVGID_00000070836956144150886670000012257414960675363220_);enable-background:new    ;}\r\n\t.st3{fill:url(#SVGID_00000160154222228853443090000017349821479291447981_);}\r\n\t.st4{opacity:0.6;fill:url(#SVGID_00000067217829684358120140000001968891562478876036_);enable-background:new    ;}\r\n\t.st5{fill:url(#SVGID_00000161604315682479158980000003378414710269303942_);}\r\n\t.st6{opacity:0.6;fill:url(#SVGID_00000168113961456702731400000016349673797841472422_);enable-background:new    ;}\r\n\t.st7{fill:url(#SVGID_00000181776413872097430070000013796877677978684088_);}\r\n\t.st8{opacity:0.6;fill:url(#SVGID_00000036942232043292410550000018067315436123455919_);enable-background:new    ;}\r\n\t.st9{fill:url(#SVGID_00000099663323907236538090000002526078043571194500_);}\r\n\t.st10{opacity:0.6;fill:url(#SVGID_00000117642739088724102300000008225911211682868659_);enable-background:new    ;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.4,336.7v-90.8c0-7.6-6.2-13.8-13.8-13.8h0c-7.6,0-13.8,6.2-13.8,13.8v90.8c0,7.6,6.2,13.8,13.8,13.8h0 C58.2,350.6,64.4,344.3,64.4,336.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.7529,
    y1: 183.5546,
    x2: 89.7914,
    y2: 183.5546
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09090B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.000804437,
    style: {
      stopColor: "#F1872D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.005260003,
    style: {
      stopColor: "#4995CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    style: {
      stopColor: "#67509C"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.4,206l25.4-25.4c5.4-5.4,5.4-14.2,0-19.6l0,0c-5.4-5.4-14.2-5.4-19.6,0l-25.4,25.4 c-5.4,5.4-5.4,14.2,0,19.6l0,0C46.2,211.4,55,211.4,60.4,206z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173855570088471301850000007633221854710121394_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.1083,
    y1: 183.5546,
    x2: 64.1469,
    y2: 183.5546
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09090B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.000804437,
    style: {
      stopColor: "#F1872D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.005260003,
    style: {
      stopColor: "#4995CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    style: {
      stopColor: "#67509C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000173855570088471301850000007633221854710121394_)",
      enableBackground: "new"
    },
    d: " M40.5,206l-25.4-25.4c-5.4-5.4-5.4-14.2,0-19.6l0,0c5.4-5.4,14.2-5.4,19.6,0l25.4,25.4c5.4,5.4,5.4,14.2,0,19.6l0,0 C54.7,211.4,45.9,211.4,40.5,206z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080205916102683623290000013682263654335280021_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.7529,
    y1: 135.3429,
    x2: 89.7914,
    y2: 135.3429
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001058023,
    style: {
      stopColor: "#5DBC9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9963,
    style: {
      stopColor: "#3F9DD6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080205916102683623290000013682263654335280021_)"
    },
    d: "M60.4,157.8l25.4-25.4 c5.4-5.4,5.4-14.2,0-19.6l0,0c-5.4-5.4-14.2-5.4-19.6,0l-25.4,25.4c-5.4,5.4-5.4,14.2,0,19.6l0,0C46.2,163.2,55,163.2,60.4,157.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110472220746232718120000017314029487036286900_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.1083,
    y1: 135.3429,
    x2: 64.1469,
    y2: 135.3429
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001058023,
    style: {
      stopColor: "#5DBC9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9963,
    style: {
      stopColor: "#3F9DD6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000110472220746232718120000017314029487036286900_)",
      enableBackground: "new"
    },
    d: " M40.5,157.8l-25.4-25.4c-5.4-5.4-5.4-14.2,0-19.6l0,0c5.4-5.4,14.2-5.4,19.6,0l25.4,25.4c5.4,5.4,5.4,14.2,0,19.6l0,0 C54.7,163.2,45.9,163.2,40.5,157.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071543601073804473730000016233369390809323184_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.7529,
    y1: 85.0797,
    x2: 89.7914,
    y2: 85.0797
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000804437,
    style: {
      stopColor: "#F1872D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9961,
    style: {
      stopColor: "#E81776"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000071543601073804473730000016233369390809323184_)"
    },
    d: "M60.4,107.6l25.4-25.4 c5.4-5.4,5.4-14.2,0-19.6l0,0c-5.4-5.4-14.2-5.4-19.6,0L40.8,88c-5.4,5.4-5.4,14.2,0,19.6l0,0C46.2,112.9,55,112.9,60.4,107.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043435644557802175500000009006226289910027152_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.1083,
    y1: 85.0797,
    x2: 64.1469,
    y2: 85.0797
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000804437,
    style: {
      stopColor: "#F1872D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9961,
    style: {
      stopColor: "#E81776"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000043435644557802175500000009006226289910027152_)",
      enableBackground: "new"
    },
    d: " M40.5,107.6L15.1,82.2c-5.4-5.4-5.4-14.2,0-19.6l0,0c5.4-5.4,14.2-5.4,19.6,0L60.1,88c5.4,5.4,5.4,14.2,0,19.6l0,0 C54.7,112.9,45.9,112.9,40.5,107.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017479609071678994890000004107280509904996023_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.7529,
    y1: 38.9195,
    x2: 89.7914,
    y2: 38.9195
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9982,
    style: {
      stopColor: "#F37C47"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017479609071678994890000004107280509904996023_)"
    },
    d: "M60.4,61.4L85.8,36 c5.4-5.4,5.4-14.2,0-19.6l0,0c-5.4-5.4-14.2-5.4-19.6,0L40.8,41.8c-5.4,5.4-5.4,14.2,0,19.6l0,0C46.2,66.8,55,66.8,60.4,61.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124150857350455368000000011578986465289965466_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.1083,
    y1: 38.9195,
    x2: 64.1469,
    y2: 38.9195
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9982,
    style: {
      stopColor: "#F37C47"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000124150857350455368000000011578986465289965466_)",
      enableBackground: "new"
    },
    d: " M40.5,61.4L15.1,36c-5.4-5.4-5.4-14.2,0-19.6l0,0c5.4-5.4,14.2-5.4,19.6,0l25.4,25.4c5.4,5.4,5.4,14.2,0,19.6l0,0 C54.7,66.8,45.9,66.8,40.5,61.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172414953504816381130000015521304173006005124_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.7529,
    y1: 230.7405,
    x2: 89.7914,
    y2: 230.7405
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6457A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC7BB1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000172414953504816381130000015521304173006005124_)"
    },
    d: "M60.4,253.2l25.4-25.4 c5.4-5.4,5.4-14.2,0-19.6l0,0c-5.4-5.4-14.2-5.4-19.6,0l-25.4,25.4c-5.4,5.4-5.4,14.2,0,19.6l0,0C46.2,258.6,55,258.6,60.4,253.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158013164965035665370000008915311955836415154_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.1083,
    y1: 230.7405,
    x2: 64.1469,
    y2: 230.7405
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6457A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC7BB1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000158013164965035665370000008915311955836415154_)",
      enableBackground: "new"
    },
    d: " M40.5,253.2l-25.4-25.4c-5.4-5.4-5.4-14.2,0-19.6l0,0c5.4-5.4,14.2-5.4,19.6,0l25.4,25.4c5.4,5.4,5.4,14.2,0,19.6l0,0 C54.7,258.6,45.9,258.6,40.5,253.2z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgBar5);
export default __webpack_public_path__ + "static/media/ProgBar_5.18bc4a025e8e1daf2638afb1d894f046.svg";
export { ForwardRef as ReactComponent };